/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBedOff = createReactComponent("bed-off", "IconBedOff", [
  ["path", { d: "M7 7a2 2 0 1 0 2 2", key: "svg-0" }],
  ["path", { d: "M22 17v-3h-4m-4 0h-12", key: "svg-1" }],
  ["path", { d: "M2 8v9", key: "svg-2" }],
  ["path", { d: "M12 12v2h2m4 0h4v-2a3 3 0 0 0 -3 -3h-6", key: "svg-3" }],
  ["path", { d: "M3 3l18 18", key: "svg-4" }]
]);

export { IconBedOff as default };
//# sourceMappingURL=IconBedOff.js.map
